/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Zoom_OutInputs */

const cs_workflow_zoom_out = /** @type {(inputs: Workflow_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oddálit`)
};

const en_workflow_zoom_out = /** @type {(inputs: Workflow_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom out`)
};

/**
* | output |
* | --- |
* | "Zoom out" |
*
* @param {Workflow_Zoom_OutInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_zoom_out = /** @type {((inputs?: Workflow_Zoom_OutInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Zoom_OutInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_zoom_out(inputs)
	return cs_workflow_zoom_out(inputs)
});